import type { TransferPlayerHeader as XpaTransferPlayerHeader } from "@motain/xpa-proto-files-web/lib/types/transfer_player_header";
import type { FC } from "react";
import { ImageWithSets } from "@/components/image-with-sets/ImageWithSets";
import type { ImageSourceSetsRecordWithoutUrl } from "@/types/of-image.types";
import { MEDIA_QUERY } from "@/constants/media-query.constant";
import { ImageRatio } from "@/constants/image-ratio.constants";
import { getImageSourceSets } from "@/utils/helpers/getImageSourceSets";
import { isNonNullable } from "@/types/isNonNullable";
import styles from "./TransferPlayerHeader.module.scss";
import classNames from "classnames";

const PLAYER_IMAGE_SOURCE_SETS_RECORD: ImageSourceSetsRecordWithoutUrl = {
  mobile: {
    media: MEDIA_QUERY.mobile,
    width: 32,
    ratio: ImageRatio.Square,
  },
  tabletPortrait: {
    media: MEDIA_QUERY.tabletPortrait,
    width: 32,
    ratio: ImageRatio.Square,
  },
  tabletLandscape: {
    media: MEDIA_QUERY.tabletLandscape,
    width: 32,
    ratio: ImageRatio.Square,
  },
  desktop: {
    media: MEDIA_QUERY.desktop,
    width: 48,
    ratio: ImageRatio.Square,
  },
};

export const TransferPlayerHeader: FC<XpaTransferPlayerHeader> = (props) => {
  const { playerImg, playerName } = props;

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        {isNonNullable(playerImg) && (
          <div className={styles.image}>
            <ImageWithSets
              classNames={styles.image}
              image={getImageSourceSets(
                PLAYER_IMAGE_SOURCE_SETS_RECORD,
                playerImg.path,
              )}
              alt={playerImg.alt}
              isPreloaded={playerImg.isPreloaded}
            ></ImageWithSets>
          </div>
        )}
      </div>
      <p className={classNames("title-4-bold", styles.name)}>{playerName}</p>
    </div>
  );
};
